import React, { VFC } from 'react'
import useAnalysis from 'hooks/useAnalysis'
import { addClassName } from 'utils'

import Img from './Img'

type Props = {
  className?: string
  direction: 'top' | 'prev' | 'restart'
  text?: string
  doubleArrow?: boolean
}

const Back: VFC<Props> = (props) => {
  const { backToTop, backToPrevQuestion, restart } = useAnalysis()
  const doubleArrow = props.doubleArrow || false
  let text
  let clickHandler

  switch (props.direction) {
    case 'top':
      text = 'TOPへ戻る'
      clickHandler = backToTop
      break

    case 'prev':
      text = '前の画面へ戻る'
      clickHandler = backToPrevQuestion
      break

    case 'restart':
      text = '最初からやり直す'
      clickHandler = restart
      break

    default:
      break
  }

  if (props.text) {
    text = props.text
  }

  return (
    <li
      className={`flex items-center cursor-pointer ${addClassName(
        props.className
      )}`}
      onClick={clickHandler}
    >
      {!doubleArrow ? (
        <div className="w-[10.8px] h-[10.8px] sm:w-[21.6px] sm:h-[21.6px] lg:w-[15.6px] lg:h-[15.6px] mr-[2px] sm:mr-[3px] lg:mr-[9px]">
          <Img src="ico-arrow-1.svg" width="21.6" height="21.6" />
        </div>
      ) : (
        <div className="w-[10.8px] h-[10.8px] sm:w-[21.6px] sm:h-[21.6px] lg:w-[15.6px] lg:h-[15.6px] mr-2 sm:mr-4 lg:mr-3">
          <Img src="ico-arrow-2.svg" width="21.6" height="21.6" />
        </div>
      )}
      <span className="text-custom-2 sm:text-2xl lg:text-base">{text}</span>
    </li>
  )
}

export default Back
